import { render, staticRenderFns } from "./SelectRestaurantViewModal.vue?vue&type=template&id=0da1d209&scoped=true&"
import script from "./SelectRestaurantViewModal.vue?vue&type=script&lang=js&"
export * from "./SelectRestaurantViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da1d209",
  null
  
)

export default component.exports